export const SW_TARGET_UPDATE_EVENT = 'sw-target-update';

export const SW_ROUTER_LINK_AVAILABLE_ATTRIBUTES = [
  'namespace',
  'path',
  'pathname',
  'hash',
  'search-params',
  'clear',
  'base',
  'target',
  'referrerpolicy',
  'hreflang',
  'prefetch',
];

export const SW_ROUTER_LINK_TARGET_AVAILABLE_ATTRIBUTES = ['namespace', 'path', 'pathname', 'hash', 'search-params'];
